import { useState, useEffect, useContext } from 'react';

import { LiveReserveContext } from '../../LiveLessonReseveContext';


// 時間選択 
function LiveReserveTime() {

  const {
    isLoading,
    lessonTermMinute,
    user, trialCount,
    instId, instructors,
    calendar,
    lsnMin, setLsnMin,
    isTrial, setIsTrial,
    isLsnSvyAddTicketTerm,
  } = useContext(LiveReserveContext);

  const [isFirstSelected, setIsFirstSelected] = useState<boolean>(false);

  const [isOpen30, setIsOpen30] = useState<boolean>(true);
  const [isOpen45, setIsOpen45] = useState<boolean>(true);


  // レッスン時間選択の初期値
  useEffect(() => {
    if(!isFirstSelected && user && trialCount!=null) {
      if(trialCount >= 2) {
        // 30分:無料
        setLsnMin(lessonTermMinute*2);
        setIsTrial(true);
      } else if(trialCount >= 1) {
        // 15分:無料
        setLsnMin(lessonTermMinute);
        setIsTrial(true);
      } else if(user?.ticket >= 6) {
        // 30分:チケット
        setLsnMin(lessonTermMinute*2);
        setIsTrial(false);
      } else {
        // 15分:チケット
        setLsnMin(lessonTermMinute);
        setIsTrial(false);
      }

      setIsFirstSelected(true);
    }
  }, [user, trialCount])


  // 講師の連続空き枠判定
  useEffect(() => {
    let newIsOpen30 = false;
    let newIsOpen45 = false;
    if(
      instId && instructors &&
      (instructors.find((inst: any) => inst.inst_id == instId))
    ) {
      // 講師選択
      const instructor = instructors.find((inst: any) => inst.inst_id == instId);
      newIsOpen30 = instructor.open_term_flg?.term_30;
      newIsOpen45 = instructor.open_term_flg?.term_45;

    } else {
      // 講師未選択:選択項目のすべての講師確認
      instructors.forEach((inst: any) => {
        if(inst.open_term_flg?.term_30) {
          newIsOpen30 = true;
        }
        if(inst.open_term_flg?.term_45) {
          newIsOpen45 = true;
        }
      });
    }

    setIsOpen30(newIsOpen30);
    setIsOpen45(newIsOpen45);
  }, [trialCount, instructors, calendar])


  // レッスン時間の選択不可が選択されていた場合
  useEffect(() => {
    if(isOpen30 && !isOpen45 && lsnMin>=lessonTermMinute*3) {
      // 45分非表示で45分選択の場合：30分選択
      setLsnMin(lessonTermMinute*2);
      setIsTrial(trialCount >= 2);
    } else if(
      // 30/45分非表示で30/45分選択の場合：15分選択
      (!isOpen30 && !isOpen45 && lsnMin>=lessonTermMinute*2) ||
      // 1枠も空いていない場合：15分選択
      (calendar && calendar.length==0 && lsnMin!=lessonTermMinute)
    ) {
      setLsnMin(lessonTermMinute);
      setIsTrial(trialCount >= 1);
    }

  }, [isOpen30, isOpen45])



  // 時間変更
  const handleTime = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    if(!isLoading) {
      const { minute, isTrial } = JSON.parse(e.target.value);
      setLsnMin(parseInt(minute, 10));
      setIsTrial(isTrial);
    }
  }


  return (
    <div>
      <div>
        <label className="control-label" style={{
          margin: '15px 0 10px 0',
          backgroundColor: '#eaffea',
          padding: '0.25em 3em 0.25em 0.5em',
          borderLeft: 'solid 5px #3c8c3c',
        }}>レッスン時間を選択</label>

        <div style={{ marginBottom: '15px' }}>
          <select
            name="lesson_minutes_type"
            className="form-control input-lg"
            id="InputSelect"
            onChange={handleTime}
            value={JSON.stringify({
              minute: lsnMin,
              isTrial: isTrial 
            })}
          >

            {/* 15分/無料 */}
            {trialCount >= 1 &&
              <option value={JSON.stringify({
                minute: lessonTermMinute,
                isTrial: true
              })}>
                {lessonTermMinute}分（無料1回分）
              </option>
            }

            {/* 30分/無料 */}
            {(isOpen30 && trialCount >= 2) &&
              <option value={JSON.stringify({
                minute: lessonTermMinute*2,
                isTrial: true
              })}>
                {lessonTermMinute*2}分（無料2回分）
              </option>
            }

            {/* 45分/無料 */}
            {(isOpen45 && trialCount >= 3) &&
              <option value={JSON.stringify({
                minute: lessonTermMinute*3,
                isTrial: true
              })}>
                {lessonTermMinute*3}分（無料3回分）
              </option>
            }

            {/* 15分/チケット */}
            {(
              user?.ticket >= 3 ||
              (user?.ticket<3 && trialCount<=0)
            ) &&
              <option value={JSON.stringify({
                minute: lessonTermMinute,
                isTrial: false
              })}>
                {lessonTermMinute}分（3チケット）
              </option>
            }

            {/* 30分/チケット */}
            {(isOpen30 && user?.ticket>=6) && (
              <option value={JSON.stringify({
                minute: lessonTermMinute*2,
                isTrial: false
              })}>
                {lessonTermMinute*2}分（6チケット）
              </option>
            )}

            {/* 45分/チケット */}
            {(isOpen45 && user?.ticket>=9) && (
              <option value={JSON.stringify({
                minute: lessonTermMinute*3,
                isTrial: false
              })}>
                {lessonTermMinute*3}分（9チケット）
              </option>
            )}

          </select>

          {/* 30分2チケット：アンケートで１チケットプレゼントキャンペーン */}
          {isLsnSvyAddTicketTerm &&
            <p
              className='text-center'
              style={{color: 'red', fontWeight: 'bold'}}
            >
              30分(6チケット)で1チケットGET🎁
              <span className="visible-xs"></span>
              16〜22日の7日間限定キャンペーン中！
            </p>
          }

        </div>
      </div>
    </div>
  );
}
  
export default LiveReserveTime;